export default __webpack_public_path__ + "static/media/cut.ebeb7cdb.svg";